/**
 * Correspondance route paramètre document ↔ type_document_id (aligné sur document.component typeDocumentIdMap).
 * À ajuster si les ids diffèrent en base.
 */
export const PARAMETRE_TYPE_DOCUMENT_VENTE = {
    devis: 7,
    commandeClient: 8,
    bonSortie: 9,
    bonLivraison: 10,
    facture: 11
} as const;

export const PARAMETRE_TYPE_DOCUMENT_ACHAT = {
    commandeFournisseur: 12,
    bonReception: 13,
    factureFournisseur: 14,
    inventaire: 15
} as const;

/** Libellé français affiché à côté du champ « Label » (paramètres document vente). */
const VENTE_DOC_TYPE_LABEL_BY_ID: Record<number, string> = {
    [PARAMETRE_TYPE_DOCUMENT_VENTE.devis]: 'Devis',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.commandeClient]: 'Commande client',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.bonSortie]: 'Bon de sortie',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.bonLivraison]: 'Bon de livraison',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.facture]: 'Facture'
};

export function getVenteDocumentTypeLabel(typeDocumentId: number): string {
    return VENTE_DOC_TYPE_LABEL_BY_ID[typeDocumentId] ?? 'Document';
}

export function parseModelesReferenceMap(raw: unknown): Record<string, number> {
    if (raw == null || raw === '') {
        return {};
    }
    let obj: unknown = raw;
    if (typeof raw === 'string') {
        try {
            obj = JSON.parse(raw);
        } catch {
            return {};
        }
    }
    if (obj == null || typeof obj !== 'object' || Array.isArray(obj)) {
        return {};
    }
    const out: Record<string, number> = {};
    for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
        const tid = Number(k);
        const mid = Number(v);
        if (Number.isFinite(tid) && tid > 0 && Number.isFinite(mid) && mid > 0) {
            out[String(Math.floor(tid))] = Math.floor(mid);
        }
    }
    return out;
}

export function resolveModeleReferenceForType(
    modelesReference: unknown,
    typeDocumentId: number | null | undefined,
    fallbackModeleReference: number | null | undefined
): number | null {
    const map = parseModelesReferenceMap(modelesReference);
    const tid = Number(typeDocumentId);
    if (Number.isFinite(tid) && tid > 0) {
        const fromMap = map[String(Math.floor(tid))];
        if (fromMap != null) {
            return fromMap;
        }
    }
    if (fallbackModeleReference != null) {
        const n = Number(fallbackModeleReference);
        if (Number.isFinite(n) && n > 0) {
            return Math.floor(n);
        }
    }
    return null;
}
